import { render, staticRenderFns } from "./ItemsMonitor.vue?vue&type=template&id=54122c02&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ItemsMonitor.vue?vue&type=script&lang=ts"
export * from "./ItemsMonitor.vue?vue&type=script&lang=ts"
import style0 from "./ItemsMonitor.vue?vue&type=style&index=0&id=54122c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54122c02",
  null
  
)

export default component.exports